// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ChoiceQuestion_abstract } from './../abstract/SagaBase/ChoiceQuestion_abstract';
export class ChoiceQuestion extends ChoiceQuestion_abstract {}
